import React from 'react';
import DiagramUtils from '../../utils/DiagramUtils';
import DiagramUI from "../DiagramUI";
import Model from "./TextModel";

export default class UI extends DiagramUI {

    state = {};

    constructor(props, context) {
        super(props, context);
    }

    render() {

        return (
            <div className={"diagram-ui " + (this.props.className || "")} style={this.props.model.toStyle()}  >
                {this.props.model.text}
            </div>
        );
    }
}

const type = new Model().getType();
DiagramUtils.register(type, {
    model: Model,
    name: type,
    alias: "文本框",
    catalog: "基础",
    catalogIndex: -90,
    svg: "#anticon-component-rich-text",
    uiGetter: (model) => <UI model={model} />
});